var map = {
	"./cs-CZ/grafana-sql.json": [
		71117,
		[
			1117
		]
	],
	"./de-DE/grafana-sql.json": [
		88260,
		[
			8260
		]
	],
	"./en-US/grafana-sql.json": [
		53495,
		[
			3495
		]
	],
	"./es-ES/grafana-sql.json": [
		40046,
		[
			46
		]
	],
	"./fr-FR/grafana-sql.json": [
		7626,
		[
			7626
		]
	],
	"./hu-HU/grafana-sql.json": [
		96244,
		[
			6244
		]
	],
	"./id-ID/grafana-sql.json": [
		93284,
		[
			3284
		]
	],
	"./it-IT/grafana-sql.json": [
		16772,
		[
			6772
		]
	],
	"./ja-JP/grafana-sql.json": [
		89124,
		[
			6743
		]
	],
	"./ko-KR/grafana-sql.json": [
		22961,
		[
			2961
		]
	],
	"./nl-NL/grafana-sql.json": [
		62450,
		[
			2450
		]
	],
	"./pl-PL/grafana-sql.json": [
		71646,
		[
			1646
		]
	],
	"./pt-BR/grafana-sql.json": [
		21990,
		[
			1990
		]
	],
	"./pt-PT/grafana-sql.json": [
		7806,
		[
			7806
		]
	],
	"./ru-RU/grafana-sql.json": [
		5664,
		[
			5664
		]
	],
	"./sv-SE/grafana-sql.json": [
		94113,
		[
			4113
		]
	],
	"./tr-TR/grafana-sql.json": [
		71249,
		[
			3630
		]
	],
	"./zh-Hans/grafana-sql.json": [
		39700,
		[
			9700
		]
	],
	"./zh-Hant/grafana-sql.json": [
		94965,
		[
			4965
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 55644;
module.exports = webpackAsyncContext;